module.exports = __webpack_public_path__ + "static/may-lg-76e27d261ebf62a993e32b89027b7828.jpg";